import { useEffect, useRef, useState } from 'react'

declare const $

export interface ErrorModalContent {
  title: string | null
  reason: unknown
}

const useErrorModal = () => {
  const [error, showError] = useState<ErrorModalContent>({ title: null, reason: null })
  const modal = useRef<ReturnType<typeof $> | null>(null)
  const button = useRef<ReturnType<typeof $> | null>(null)
  const title = useRef<ReturnType<typeof $> | null>(null)
  const reason = useRef<ReturnType<typeof $> | null>(null)

  useEffect(() => {
    const errorModal = $('#error-modal-react')
    modal.current = errorModal
    button.current = errorModal.find('.show-error-modal')
    title.current = errorModal.find('.modal-title')
    reason.current = errorModal.find('.modal-reason')
  }, [])

  useEffect(() => {
    const flatten = (formErrors, messages) => {
      if (formErrors.type && formErrors.message) {
        messages.push(formErrors.message)
        return
      }
      if (formErrors instanceof Array) {
        formErrors.forEach((err) => {
          flatten(err, messages)
        })
      } else {
        Object.keys(formErrors).forEach((key) => {
          const formError = formErrors[key]
          flatten(formError, messages)
        })
      }
    }

    if (error.title || error.reason) {
      title.current.text(error.title)
      reason.current.children('p').remove()
      let reasons: unknown[]
      if (typeof error.reason === 'string') {
        reasons = [error.reason]
      } else if (error.reason instanceof Array) {
        reasons = error.reason
      } else {
        reasons = []
        flatten(error.reason, reasons)
      }
      reasons.forEach((message) => {
        reason.current.append($('<p class="reason m-0"></p>').text(message))
      })
      modal.current.modal('show')
    }
  }, [error])

  return showError
}

export default useErrorModal
